import { Button } from '@mui/material';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import RHFEmailsChips from 'src/components/elements/EmailsChips/RHFEmailsChips';
import RHFTextArea from 'src/components/elements/TextArea/RHFTextArea';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';

export interface ShareProfileFormValues {
  emails: string[];
  comments?: string;
}

const validationSchema = yup.object().shape({
  emails: yup.array(yup.string().email()).min(1, 'Must have at least 1 email'),
  comments: yup.string(),
});

interface ShareProfileFormProps {
  loading: boolean;
  onSubmit: (data: ShareProfileFormValues) => void;
}

const ShareProfileForm = function ShareProfileForm(props: ShareProfileFormProps) {
  const { loading, onSubmit } = props;
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<ShareProfileFormValues>({
    resolver,
  });
  const {
    handleSubmit,
  } = methods;

  const submitHandler: SubmitHandler<ShareProfileFormValues> = async (data) => {
    console.log('data', data);
    onSubmit(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)} className="bg-white p-10 flex gap-8 justify-center items-center flex-col">
        <div className="font-bold">Share profile</div>
        <div className="w-[400px] flex-shrink-0">
          <RHFEmailsChips
            control={methods.control}
            name="emails"
            label="Emails"
            placeholder="Emails"
            disabled={loading}
          />
        </div>
        <div className="w-[400px] flex-shrink-0">
          <RHFTextArea
            control={methods.control}
            name="comments"
            label="Comments"
            rows={3}
            disabled={loading}
          />
        </div>
        <div className="w-full justify-center flex">
          <Button variant="contained" type="submit" size="small" className="font-medium rounded-full" disabled={loading}>Share Profile</Button>
        </div>
      </form>
    </FormProvider>
  );
};

ShareProfileForm.defaultProps = {

};

ShareProfileForm.propTypes = {

};

export default ShareProfileForm;
